import { types } from "./types";

export const setReturnUrl = url => ({
  type: types.SET_RETURN_URL,
  payload: url
});

export const setOpportunity = opportunity => ({
  type: types.SET_OPPORTUNITY,
  payload: opportunity
});
